import { RewardsAccountApi, RewardPrizeApi, RewardsClaimApi, RewardsClaim, RewardTransactionApi } from '@shared/sdk-v1';
import { apiConfig } from '../shared/api-config';

export const useRewardsApi = () => {
  const rewardsAccountApi = new RewardsAccountApi(apiConfig());
  const rewardPrizeApi = new RewardPrizeApi(apiConfig());
  const rewardsClaimApi = new RewardsClaimApi(apiConfig());
  const rewardTransactionApi = new RewardTransactionApi(apiConfig());

  const claimReward = async (userId: number, courierId: number, prizeId: number): Promise<boolean> => {
    const result = await rewardsClaimApi.rewardsClaimClaimReward({
      rewardsClaimClaimRewardRequest: {
        userId: userId,
        rewardId: prizeId
      }
    });
    return result;
  };

  const getRewardsAccount = async (userId: number, courierId: number) => {
    const accounts = await rewardsAccountApi.rewardsAccountFind({
      filter: JSON.stringify({
        where: {
          courierUserId: userId,
          courierId: courierId
        }
      })
    });
    return accounts[0] || null;
  };

  const getAvailableRewards = async (courierId: number) => {
    const rewards = await rewardPrizeApi.rewardPrizeFind({
      filter: JSON.stringify({
        where: {
          courierId: courierId,
          isActive: true
        }
      })
    });
    return rewards;
  };

  const getRewardsClaims = async (userId: number, courierId: number) => {
    const claims = await rewardsClaimApi.rewardsClaimFind({
      filter: JSON.stringify({
        where: {
          courierUserId: userId,
          courierId: courierId
        },
        include: ['rewardPrize']
      })
    });
    return claims;
  };

  const getRewardTransactions = async (userId: number, courierId: number) => {
    const transactions = await rewardTransactionApi.rewardTransactionFind({
      filter: JSON.stringify({
        where: {
          courierUserId: userId,
          courierId: courierId
        },
        include: [{
          relation: 'courierPackage',
          scope: {
            fields: {
              id: true,
              trackingNo: true,
            }
          }
        }],
        order: ['createdOn DESC']
      })
    });
    return transactions;
  };

  return {
    claimReward,
    getRewardsAccount,
    getAvailableRewards,
    getRewardsClaims,
    getRewardTransactions
  };
};